import { Component } from '@angular/core';

@Component({
    selector: 'app-index',
    templateUrl: './index.component.html',
    styleUrl: './index.component.css',
    standalone: false
})
export class IndexComponent {
  acao = true;
  tarefa = false;
  documentoCliente = false;
  documento = false

  private fecharTodos() {
    this.acao = false;
    this.tarefa = false;
    this.documentoCliente = false;
    this.documento = false
  }

  public showAcao(){
    this.fecharTodos();
    this.acao = true;
  }

  public showDocumentosCliente(){
    this.fecharTodos();
    this.documentoCliente = true;
  }

  public showTarefa(){
    this.fecharTodos();
    this.tarefa = true;
  }

  public showDocumento(){
    this.fecharTodos();
    this.documento = true;
  }
}
